<template >
    <el-dialog width="400px" title="Preview sms" :visible.sync="showPopup">
        <div class="message-blue">
            <p class="message-content">...</p>
            <!-- <div class="message-timestamp-left">SMS 13:37</div> -->
        </div>

        <div class="message-orange">
            <p class="message-content">{{selectedObject.Content}}</p>
            <div class="message-timestamp-right">{{selectedObject.Data | DataOraFaraSec}}</div>
        </div>
        <!-- <div class="text-bar">
            <p class="content">
                Mesaj
            </p>
            <el-button
              class="btn"
              icon="el-icon-position"
              circle
              size="mini"
              disabled
            /> 
        </div> -->
    </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import moment from 'moment';
export default {
    name: 'Preview_sms',
    extends: BasePage,
    data() {
        return {
            showPopup: false,
            selectedObject: {
                Content: ''
            }
        }
    },
    methods: {
        async get_info(id) {
            let args = { Id: id };
            let res = await this.post('admin/log_mesaj/get_info_for_sms', args);
            if (res.Raspuns) {
                this.selectedObject = res.Raspuns;

            }
        },
        show_me(id) {

            this.get_info(id);
            this.showPopup = true;

        }
    }
}
</script>


<style lang="less" scoped>
.message-blue {
    position: relative;
    margin-left: 20px;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #A8DDFD;
    width: 200px;
    height: 50px;
    text-align: left;
    font: 400 .9em 'Open Sans', sans-serif;
    border: 1px solid #97C6E3;
    border-radius: 10px;
}

.message-orange {
    position: relative;
    margin-bottom: 10px;
    margin-left: calc(100% - 240px);
    padding: 15px;
    background-color: #f8e896;
    width: 200px;
    height: auto;
    text-align: left;
    font: 400 .9em 'Open Sans', sans-serif;
    border: 1px solid #dfd087;
    border-radius: 10px;

}

.message-content {
    padding: 0;
    margin: 0;
}

.message-timestamp-right {
    position: absolute;
    font-size: .85em;
    font-weight: 300;
    bottom: 5px;
    right: 5px;
}

.message-timestamp-left {
    position: absolute;
    font-size: .85em;
    font-weight: 300;
    bottom: 5px;
    left: 5px;
}

.message-blue:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 15px solid #A8DDFD;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    top: 0;
    left: -15px;
}

.message-blue:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 17px solid #97C6E3;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    top: -1px;
    left: -17px;
}

.message-orange:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: 15px solid #f8e896;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    bottom: 0;
    right: -15px;
}

.message-orange:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: 17px solid #dfd087;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    bottom: -1px;
    right: -17px;
}

.text-bar {
    width: 100%;
    border: 1px solid rgb(86, 86, 86);
    background-color: #ffffff;
    border-radius: 30px;
    padding: 5px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    vertical-align: center;
    user-select: none;
    p {
        margin: 0;
        padding: 0;
        font-weight: bold;
        font: 400 .9em 'Open Sans', sans-serif;

    }
    .btn {
        text-align: center;
        background-color: #f8e896;
        margin: 0;
        padding: 7px;
    }
}

</style>